export const TRANSLATE_OVERRIDES = {
    1: 0,
    2: 50,
    3: 50
}
